/*
 * The mounted SliderHost.
 *
 * `SliderService` opens a slide-out by handing the request to the host component, which renders it
 * and returns the close/dismiss promise. This was the `services.sliderHost` bridge entry (step 41
 * of #614); it is a plain module now so neither side has to import the other.
 */
let host = null

export default {
  register(theHost) {
    host = theHost
  },

  unregister(theHost) {
    if (host === theHost) {
      host = null
    }
  },

  open(request) {
    if (!host) {
      return Promise.reject(new Error('No slider host is mounted'))
    }

    return host.open(request)
  },
}
